import { mapValues } from 'lodash';
import SHORTCUTS from 'constants/keyboardShortcutsMenu';
import getPath from './getPath';

const attachActionToHotKeys = (handler, hotKeys) =>
  mapValues(hotKeys, (key, action) => () => handler(action));

const useNavigationShortcuts = (url, sideEffect) => {
  const handleShortcut = action => {
    const path = getPath(action);

    sideEffect(`${url}/${path}`);
  };

  const handlers = attachActionToHotKeys(handleShortcut, SHORTCUTS);

  return {
    handlers,
    shortcuts: SHORTCUTS,
  };
};

export default useNavigationShortcuts;
